<template>
  <div v-if="can('list-setting')">
    <h2>Setting</h2>
    <div class="list-table">
      <div class="col-md-12">
        <div class="block-right col-md-2">
          <div class="btn-group float-right" style="margin-bottom: 5px">
            <input
              type="text"
              class="float-right form-control"
              style="margin: 0px"
              placeholder="Search"
              v-model="query"
              v-on:keyup.enter="search()"
            />
            <span
              class="fa fa-search btn btn-success"
              style="cursor: pointer"
              v-on:click="search()"
            />
          </div>
        </div>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th>Key</th>
            <th>Title</th>
            <th>Value</th>
            <th>Sort</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="data in settingList" :key="data.id">
            <td>{{ data.key }}</td>
            <td>{{ data.title }}</td>
            <td>{{ data.value }}</td>
            <td>{{ data.sort }}</td>
            <td v-html="statusHtml(data.status)"></td>

            <td>
              <router-link
                :to="{
                  name: 'EditSetting',
                  params: {
                    id: data.id,
                  },
                }"
              >
                <i class="fa fa-edit text-warning" title="Edit"></i> &nbsp;
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="row">
        <div class="col-md-6">
          <select class="form-control" v-model="currentPage">
            <option v-for="i in lastPage" :key="i" :value="i">
              Jump To Page {{ i }}
            </option>
          </select>
        </div>
        <div class="col-md-6">
          <paginate
            class="block-right"
            containerClass="pagination"
            pageLinkClass="page-link"
            pageClass="page-item"
            prev-text="Prev"
            next-text="Next"
            prev-link-class="page-link"
            next-link-class="page-link"
            :page-count="lastPage"
            :click-handler="paginationClickHandler"
            v-model="currentPage"
          >
          </paginate>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SettingList",
  data() {
    return {
      settingList: [],
      lastPage: 1,
      query: "",
      currentPage: 1,
    };
  },
  mounted() {
    // // if (this.can("list-setting")) {
    this.getSettingList();
    // } else {
    //   this.$router.push({ name: "Dashboard" });
    // }
  },
  methods: {
    paginationClickHandler(pageNum) {
      this.currentPage = pageNum;
      this.getSettingList();
    },
    search() {
      this.currentPage = 1;
      this.getSettingList();
    },
    getSettingList() {
      this.$http
        .get(`setting?page=${this.currentPage}&q=${this.query}`)
        .then((res) => {
          if (res.data.status == 1) {
            this.settingList = res.data.data.data;
            this.lastPage = res.data.data.last_page;
          } else {
            this.$notify({
              group: "notifications",
              title: res.data.message,
              type: "error",
              text: res.data.errors[0],
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  watch: {
    currentPage: function () {
      this.getSettingList();
    },
  },
};
</script>
